import { useSelector } from 'react-redux';
import { name } from '~slices/activePlaySession/constants';
export var activePlaySessionSelector = function (state) { return state[name]; };
export var activePlaySessionDataSelector = function (state) {
    return activePlaySessionSelector(state).data;
};
export var useActivePlaySessionDataSelector = function () {
    return useSelector(activePlaySessionDataSelector);
};
